import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { ScrollableToolbar } from 'src/core/ui/ScrollableToolbar';
import { EventWithData, ListingMetrics } from 'src/WebApiController';

import * as styles from './PortfolioInsights.css';
import { usePortfolioInsightMetrics } from './PortfolioInsights.hooks';
import { InsightMetrics } from './PortfolioInsights.types';

export const PortfolioInsights = ({
  events,
  eventMetrics,
}: {
  events: EventWithData[];
  eventMetrics?: Record<string, ListingMetrics>;
}) => {
  const { insightMetrics } = usePortfolioInsightMetrics(events, eventMetrics);

  return (
    <ScrollableToolbar
      style={{
        overflow: 'unset',
        paddingLeft: vars.spacing.m,
        paddingRight: vars.spacing.m,
      }}
      className={styles.hideHorizontalScrollbar}
      scrollButtonClassName={styles.scrollButton}
    >
      <Stack direction="row" gap="m" style={{ flex: 1 }}>
        {insightMetrics.map((metric) => {
          return <PortfolioInsightCard key={metric.title} insight={metric} />;
        })}
      </Stack>
    </ScrollableToolbar>
  );
};

const PortfolioInsightCard = ({ insight }: { insight: InsightMetrics }) => {
  return (
    <Stack
      direction="column"
      justifyContent="spaceBetween"
      className={styles.portfolioInsightContainer}
    >
      <div className={styles.portfolioInsightTitle}>
        <Content id={insight.title} />
      </div>
      <Stack direction="column" gap="s">
        <Stack gap="s" className={styles.portfolioInsightPrimaryMetrics}>
          {insight.mainMetrics}
          {insight.mainMetricsBadge && (
            <span className={styles.portfolioInsightSecondaryMetrics}>
              {insight.mainMetricsBadge}
            </span>
          )}
        </Stack>
        <div className={styles.portfolioInsightSecondaryMetrics}>
          {insight.subMetrics}
        </div>
      </Stack>
    </Stack>
  );
};
